export default __webpack_public_path__ + "static/media/percent-voucher.ed8e147d.png";